var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDownBlack = function SvgArrowDownBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5481 8.89977L11.9928 14.2027L6.43758 8.89977C5.87919 8.36674 4.97718 8.36674 4.41879 8.89977C3.8604 9.4328 3.8604 10.2938 4.41879 10.8269L10.9906 17.1002C11.549 17.6333 12.451 17.6333 13.0094 17.1002L19.5812 10.8269C20.1396 10.2938 20.1396 9.4328 19.5812 8.89977C19.0228 8.38041 18.1065 8.36674 17.5481 8.89977Z",
    fill: "#353247"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ArrowDownBlack.428be97210d1950f1d0439d9aba3f12a.svg";